import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const isEmbedInSelection = TiptapContentResolver.create((content) => {
  if (Array.isArray(content)) {
    const node = content.find((node2) => {
      return node2.type.name === Node_Type.EMBED;
    });
    return !!node;
  }
  return false;
});
export {
  isEmbedInSelection
};
//# sourceMappingURL=is-embed-in-selection.js.map
